import { Component, OnInit, inject } from '@angular/core';
import { GameSearchService } from '../../../../services/games/game-search.service';
import { GameFilterService } from '../../../../services/games/game-filter.service';
import { GameAttribute } from 'src/app/core/services/games/game-attribute';
import { GameListConfig, GameListComponent } from "../../../components/game-list/game-list.component";
import { TranslatePipe } from '../../../../services/translation/translate.pipe';
import { PreloaderComponent } from '../../../components/preloader/preloader.component';
import { GamePreviewComponent } from '../../../components/game-preview/game-preview.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-games-search-bar',
    templateUrl: './games-search-bar.component.html',
    styleUrls: ['./games-search-bar.component.scss'],
    imports: [GamePreviewComponent, GameListComponent, PreloaderComponent, AsyncPipe, TranslatePipe]
})
export class GamesSearchBarComponent implements OnInit {
  gamesSearch = inject(GameSearchService);
  gameFilter = inject(GameFilterService);


  public hotGameListConfig: GameListConfig = {
    filter: {
      attribute: GameAttribute.HOT,
      limit: 5
    },
    title: 'link.top',
    link: '/games/hot'
  };

  ngOnInit(): void {
  }

}
